module.exports = __webpack_public_path__ + "img/ico-fb.7f11cf91.svg";